'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$rootScope', 'OperatorService', 'AuditService',
    function ($scope, $rootScope, OperatorService, AuditService) {

        $scope.update = update;
        $scope.getOperatorDisplayName = OperatorService.getDisplayName;
        $scope.isBetween = OperatorService.isBetween;

        // инициализация
        init();

        // region Function

        function init() {
            $rootScope.title = "Аудит";

            // инициализация модели
            $scope.dateFormat = 'dd.MM.yyyy';
            $scope.filters = [];
            $scope.filter = {
                action: null
            };
            $scope.def = {};
            $scope.tables = [];

            OperatorService.api.numeric(null, (data) => $scope.operators = data._embedded);

            OperatorService.api.default(null, (data) => {
                $scope.defaultOperator = data._embedded;
                $scope.filter = _getDefault();
            });

            AuditService.api.tables(null, (data) => {
                $scope.tables = [{
                    id: null,
                    name: null,
                    description: '<Все>'
                }].concat(data._embedded);
                $scope.tables.sort(function (a, b) {
                    return a.description.localeCompare(b.description);
                });
            });
        }

        function _getDefault() {
            return {
                operatorActionDate: $scope.defaultOperator,
                action: null,
                actionDate1: null,
                actionDate2: null,
                table: {
                    id: null,
                    name: null,
                    description: "<Все>"
                }
            };
        }

        function update() {
            $scope.filters = [];
            if ($scope.filter.action !== null) {
                $scope.filters.push(`'action' EQ '${$scope.filter.action}'`);
            }
            if ($scope.filter.actionDate1 !== null) {
                if ($scope.isBetween($scope.filter.operatorActionDate)) {
                    $scope.filters.push("'actionDate' GE '" + $scope.filter.actionDate1 + "'");
                    if ($scope.filter.actionDate2 !== null) {
                        $scope.filters.push("'actionDate' LE '" + $scope.filter.actionDate2 + "'");
                    }
                } else {
                    $scope.filters.push("'actionDate' " + $scope.filter.operatorActionDate + " '" + $scope.filter.actionDate1 + "'");
                }
            }
            if ($scope.filter.table.id !== null) {
                $scope.filters.push("'dataSet' EQ '" + $scope.filter.table.name + "'");
            }
        }

        // endregion

    }];
